<template>
  <div
    class="approvals-panel-back"
    role="button"
    tabindex="0"
    aria-label="Back"
    @click="$emit('click')"
    @keydown.enter="$emit('click')"
  >
    <DpplSvg file-name="icon-arrow-back" />
  </div>
</template>

<script setup>
import DpplSvg from '@/components/datapeople/DpplSvg.vue';

defineEmits(['click']);
</script>

<style scoped lang="less">
.approvals-panel-back {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 24px;
  height: 24px;
  cursor: pointer;
  color: @grey-700;

  :deep(svg) {
    width: 15px;
    height: 15px;
  }
}
</style>
